export const images = {
  amuletHero: require('./images/amulet-hero.jpg'),
  blessLight: require('./images/bless-light.jpg'),
  cat: require('./images/cat.jpg'),
  clanExuberance: require('./images/clan-exuberance.jpg'),
  clanFortune: require('./images/clan-fortune.jpg'),
  clanUnity1: require('./images/clan-unity-1.jpg'),
  clanUnity2: require('./images/clan-unity-2.jpg'),
  clanUnity3: require('./images/clan-unity-3.jpg'),
  clanUnity4: require('./images/clan-unity-4.jpg'),
  dandy: require('./images/dandy.jpeg'),
  dragon: require('./images/dragon.jpg'),
  hat: require('./images/hat.jpg'),
  iren: require('./images/iren.jpg'),
  matryoshka: require('./images/matryoshka.jpeg'),
  olyHero: require('./images/oly-hero.jpeg'),
  pie: require('./images/pie.jpg'),
  pieHigh: require('./images/pie-high.jpg'),
  pirate: require('./images/pirate.jpg'),
  ragu: require('./images/ragu.jpg'),
  rune1: require('./images/rune-one.jpg'),
  runeFrequenter: require('./images/rune-frequenter.jpeg'),
  savior: require('./images/savior.jpeg'),
  scroll: require('./images/scroll.jpg'),
  scrollCastle: require('./images/scroll-castle.jpg'),
  scrollCastleMedium: require('./images/scroll-castle-medium.jpg'),
  scrollHigh: require('./images/scroll-high.jpg'),
  scrollMedium: require('./images/scroll-medium.jpg'),
  scrollOly: require('./images/scroll-oly.jpg'),
  storm: require('./images/storm.jpg'),
  tears: require('./images/tears.jpg'),
  tower: require('./images/tower.jpg'),
};
